<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.marka_ozel_niteligi"  url="BrandCustomAttributes" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">


<div class="mt-4">
<!--name and translations -->
<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>


<div   v-for="language in languages" :key="item.id">
<ClickEditInputText  v-for="translation in item.translations" :key="translation.id" :title="language.name+ ' '+$store.state.languages.lang_phrases.isim" :value="translation.translation" :valkey="translation.id" @dataChanged="translationChanged" v-show="translation.language_id == language.id"></ClickEditInputText>	
</div>
<!--name and translations -->

<hr>

<ClickEditSelect :title="$store.state.languages.lang_phrases.tur" :value="item.type" :options="types" valkey="type" @dataChanged="dataChanged"  />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.tedarikcilerle_paylas" :value="item.share_with_supplier" valkey="share_with_supplier" @dataChanged="dataChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.tedarikciler_duzenleyebilir"  :value="item.supplier_can_edit" valkey="supplier_can_edit" @dataChanged="dataChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.tedarikciler_duzenlemek_zorunda" v-if="item.supplier_can_edit" :value="item.supplier_must_edit" valkey="supplier_must_edit" @dataChanged="dataChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.marka_yetkilisi_duzenleyebilir"  :value="item.brand_manager_can_edit" valkey="brand_manager_can_edit" @dataChanged="dataChanged" />


<!--default -->
<ClickEditInputText  v-if="item.type=='text'" :title="$store.state.languages.lang_phrases.varsayilan_deger" :value="item.default" valkey="default" @dataChanged="dataChanged"></ClickEditInputText>

<ClickEditNumber  v-if="item.type=='number'" :title="$store.state.languages.lang_phrases.varsayilan_deger" :value="item.default" valkey="default" @dataChanged="dataChanged"></ClickEditNumber>

<ClickEditSelect  v-if="item.type=='boolean' || item.type=='select'" :title="$store.state.languages.lang_phrases.varsayilan_deger" :options="defaultoptions" :value="item.default" valkey="default" @dataChanged="dataChanged"></ClickEditSelect>
<!--default -->




<template  v-if=" item.type=='select' || item.type=='multiselect'">
	<hr>
<h4 class="text-primary">{{$store.state.languages.lang_phrases.opsiyonlar}}</h4>




<Fieldset v-for="option in item.options" :legend="option.name"  :toggleable="true" class="mt-2 mb-2" :collapsed="true" v-show="option.id !==0">
<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="option.name" :valkey="option.id" @dataChanged="optionChanged"></ClickEditInputText>

<div  v-for="language in languages" :key="language.id">
<ClickEditInputText  v-for="translation in option.translations" :key="translation.id" :title="language.name+ ' '+$store.state.languages.lang_phrases.isim" :value="translation.translation" :valkey="translation.id" @dataChanged="optiontranslationChanged" v-show="translation.language_id == language.id"></ClickEditInputText> 
</div>


<ClickEditColorPicker  :title="$store.state.languages.lang_phrases.renk" :value="option.color" :valkey="option.id" @dataChanged="colorChanged" @addColor="addColor"></ClickEditColorPicker>

<!--
<div class="grid">
<div class="col-3 md:col-2">
<p class="click_edit_value_title">Renk:</p>
</div>
<div class="col-9 md:col-10"  >
  <template v-if="option.color">
    <ColorPicker v-model="option.color" @hide="colorChanged(option.id,option.color)" class="mt-3"/>
  </template>
  <template v-else>
   <p class="click_edit_value animate_class" @click="addColor(option.id)"> Renk Belirlenmemiz</p>
  </template>

</div>
</div>

-->


<hr>
  <div class="flex align-items-center justify-content-end mb-6">
    
  <Button :label="$store.state.languages.lang_phrases.sil" icon="pi pi-check" class="p-button-danger p-button-sm p-button-outlined" @click="deleteOption(option.id)"/>
</div>
</Fieldset>









<br/>
<ClickAddInputText  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="new_phrase" @newAdded="newOptionAdded"></ClickAddInputText>
</template>





<template  v-if=" item.type=='categorised'">
<hr>
<h4 class="text-primary">{{$store.state.languages.lang_phrases.kategoriler}}</h4>

<draggable 
v-model="item.rootcategories"
class="list-group" 
group="parent" 
@start="start" 
@end="end" 
@change="change"
v-bind="dragOptions"
item-key="id">

<template #item="{element}">
<CascadeCategoryBrandAttribute  :category="element" :key="element.id" :languages="languages"  @dataRenewed="renewData" :is_cascade="false"></CascadeCategoryBrandAttribute>
</template>




</draggable>


<!--<CategoryBrandAttribute v-for="category in item.rootcategories" :category="category" :key="category.id" :languages="languages"  @dataRenewed="renewData"></CategoryBrandAttribute>-->


<br/>
<ClickAddInputText  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="new_phrase" @newAdded="newCategoryAdded"></ClickAddInputText>
</template>



<template  v-if=" item.type=='cascadecategorised'">
<hr>
<h4 class="text-primary">{{$store.state.languages.lang_phrases.kategoriler}}</h4>

<draggable 
v-model="item.rootcategories"
class="list-group" 
group="parent" 
@start="start" 
@end="end" 
@change="change"
v-bind="dragOptions"
item-key="id">

<template #item="{element}">
<CascadeCategoryBrandAttribute  :category="element" :key="element.id" :languages="languages"  @dataRenewed="renewData" :is_cascade="true"></CascadeCategoryBrandAttribute>
</template>




</draggable>






<br/>
<ClickAddInputText  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="new_phrase" @newAdded="newCategoryAdded"></ClickAddInputText>

</template>







<br/><br/><br/><br/><br/>
</div>











</template>

</div>
</template>
<script>
import CategoryBrandAttribute from "./CategoryBrandAttribute"
import CascadeCategoryBrandAttribute from "./CascadeCategoryBrandAttribute"

export default {

  name: 'BrandCustomAttribute',
  components:{CategoryBrandAttribute,CascadeCategoryBrandAttribute},
 data () {
    return {   
    	loading:true, 
      drag:false,
    	item:null,	
    	tabactiveindex:null,
    	languages:[],
    	defaultoptions:[{name:"Açık",id:1},{name:"Kapalı",id:0}],
    	types:[
	        {
	          name:"Metin",
	          id:"string"
	        },
	        {
	          name:"Sayı",
	          id:"number"
	        },
	        {
	          name:"Açık/kapalı",
	          id:"boolean"
	        },
          {
            name:"Opsiyonlu",
            id:"select"
          },
          {
            name:"Çoklu Seçim Opsiyonlu",
            id:"multiselect"
          },
          {
            name:"Kategori",
            id:"categorised"
          },
          {
            name:"Kademeli Kategori",
            id:"cascadecategorised"
          },
	    ],
    }
  },
  computed:{
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.renewData()
  		}
  	}
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
    start(event)
    {
      this.drag = true
    },
    end(event)
    { 
      this.drag = false
    },
    change(event)
    {   
      console.log(this.item.rootcategories)
      let formdata = new FormData()
      formdata.append("categories",JSON.stringify(this.item.rootcategories))
      this.generalSubmission(formdata,"custom_attribute/reorder_categories",this.renewData)
    },
    addColor(data)
    {      
      let option_id = data.key
      let ind = this.item.options.findIndex((item)=>{return item.id == option_id})
      this.item.options[ind].color = "ffffff"
    },
    cancelAddColor(option_id)
    {
      let ind = this.item.options.findIndex((item)=>{return item.id == option_id})
      this.item.options[ind].color = null
    },
  	async getData()
  	{
  		this.loading = await true
  		this.item = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute/"+this.$route.params.attribute_id)
  		
  		this.languages = await this.generalApiGetWithoutLoader("languages")
  		await console.log(this.languages)

  		if(this.item.type=="boolean")
  		{
  			this.defaultoptions = await [{name:"Varsayılan yok",id:null},{name:"Açık",id:1},{name:"Kapalı",id:0}]
  		}
  		if(this.item.type=="select")
  		{
  			this.defaultoptions = await this.item.options
  			await this.item.options.unshift({name:"Varsayılan yok",id:0});
  		}

  		if(this.item.type!=="text")
  		{
  			this.item.default = await parseFloat(this.item.default)
  		}
  		
  		await console.log(this.item)
         
        /*
        this.fields[0].value = await data.name
        await console.log(this.fields[0].value)

        if(data.type=="string")
        {
        	this.fields[1].value = await {name:"Metin",id:"string"}
        	this.fields[2].value = await data.default
        }
        if(data.type=="number")
        {
        	this.fields[1].value = await {name:"Sayı",id:"number"}
        	this.fields[3].value = await parseFloat(data.default)
        }
        if(data.type=="switch")
        {
        	this.fields[1].value = await {name:"Açık/kapalı",id:"switch"}
        	this.fields[5].options = await [{name:"Açık",id:1},{name:"Kapalı",id:0}]
        	this.fields[5].value = await this.fields[5].options.find((item)=>{return item.id == parseFloat(data.default)})
        }
        if(data.type=="select")
        {
        	this.fields[1].value = await {name:"Opsiyonlu",id:"select"}
        	let options = await []
        	for(let item of data.options)
        	{
        		await options.push({name:item.name,id:item.id})
        	}
        	this.fields[4].value = await options
        	this.fields[5].options = await options
        	this.fields[5].value = await this.fields[5].options.find((item)=>{return item.id == parseFloat(data.default)})
        }
        */
        


        this.loading = await false
  	},
  	translationChanged(data)
  	{
  			console.log(data.value)
    		console.log(data.key)
    		let formdata = new FormData()
    		formdata.append("data",data.value)
    		this.generalSubmission(formdata,"custom_attribute/update_translation/"+data.key,this.renewData)
  	},
    colorChanged(data)
    {
      console.log(data)     
      let formdata = new FormData()
      formdata.append("color",data.value)
      this.generalSubmission(formdata,"custom_attribute/update_option/"+data.key,this.renewData)
    },
  	optionChanged(data)
  	{
  			console.log(data)
    		console.log(data.key)
    		let formdata = new FormData()
    		formdata.append("name",data.value)
    		this.generalSubmission(formdata,"custom_attribute/update_option/"+data.key,this.renewData)
  	},
  	optiontranslationChanged(data)
  	{
  			console.log(data.value)
    		console.log(data.key)
    		let formdata = new FormData()
    		formdata.append("data",data.value)
    		this.generalSubmission(formdata,"custom_attribute/update_option_translation/"+data.key,this.renewData)
  	},
  	deleteOption(id)
  	{
  		this.deleteItem("custom_attribute_option",id)
  	},
    newCategoryAdded(data)
    {
      let formdata = new FormData()
      formdata.append("name",data.value)
      formdata.append("parent",0)
      this.generalSubmission(formdata,"custom_attribute/store_category/"+this.item.id,this.renewData)
    },
  	newOptionAdded(data)
    {
    	console.log(data)
    	//return false
      let formdata = new FormData()
      formdata.append("name",data.value)     
      this.generalSubmission(formdata,"custom_attribute/store_option/"+this.item.id,this.renewData)
    },
  	async renewData(response)
  	{
      console.log("dataRenewed")
  		this.tabactiveindex = await null
  		this.item = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute/"+this.$route.params.attribute_id)
  		
  		this.languages = await this.generalApiGetWithoutLoader("languages")
  		await console.log(this.languages)

  		if(this.item.type=="boolean")
      {
        this.defaultoptions = await [{name:"Varsayılan yok",id:null},{name:"Açık",id:1},{name:"Kapalı",id:0}]
      }
      if(this.item.type=="select")
      {
        this.defaultoptions = await this.item.options
        await this.item.options.unshift({name:"Varsayılan yok",id:0});
      }

      if(this.item.type!=="text")
      {
        this.item.default = await parseInt(this.item.default)
      }

  	},

  	dataChanged(data)
    {
    	console.log(data.value)
    	console.log(data.key)
    	let formdata = new FormData()
    	formdata.append(data.key,data.value)
    	this.generalSubmission(formdata,"custom_attribute/update/"+this.item.id,this.renewData)
    },
    afterdataChanged(response)
    {
    	console.log("data changed");
    	console.log(response.data);    	
    },
  }
};
</script>

<style lang="css" scoped>
</style>